export default "__VITE_ASSET__840ed5b3__"